import React, { useState } from 'react';
import { Typography, Input, List, Select, Button, Card, Row, Col } from 'antd';
import DashboardLayout from '../components/DashboardLayout';
import '../styles/ChainList.css'; // Import the CSS

const { Title } = Typography;
const { Search } = Input;
const { Option } = Select;

// Mock data for supported chains
const chains = [
  { name: 'Ethereum', type: 'Mainnet' },
  { name: 'Polygon', type: 'Mainnet' },
  { name: 'Binance Smart Chain', type: 'Mainnet' },
  { name: 'Avalanche', type: 'Mainnet' },
  { name: 'Fantom', type: 'Mainnet' },
  { name: 'Goerli Testnet', type: 'Testnet' },
  { name: 'Mumbai Testnet', type: 'Testnet' },
];

const ChainList: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [filteredChains, setFilteredChains] = useState(chains);
  const [viewMode, setViewMode] = useState<'list' | 'grid'>('list');

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    filterChains(value, filterType);
  };

  const handleFilter = (type: string) => {
    setFilterType(type);
    filterChains(searchTerm, type);
  };

  const filterChains = (search: string, type: string) => {
    const filtered = chains.filter((chain) => {
      const matchesSearch = chain.name.toLowerCase().includes(search.toLowerCase());
      const matchesType = type === 'All' || chain.type === type;
      return matchesSearch && matchesType;
    });
    setFilteredChains(filtered);
  };

  return (
    <DashboardLayout>
      <div className="chainlist-container">
        <Title level={3} className="chainlist-title">Chain List</Title>
        <p className="chainlist-description">Search and filter supported blockchain chains here.</p>
        <div className="chainlist-controls">
          <Search
            placeholder="Search chains..."
            allowClear
            onSearch={handleSearch}
          />
          <Select
            value={filterType}
            onChange={handleFilter}
          >
            <Option value="All">All</Option>
            <Option value="Mainnet">Mainnet</Option>
            <Option value="Testnet">Testnet</Option>
          </Select>
          <Button
            type={viewMode === 'list' ? 'primary' : 'default'}
            onClick={() => setViewMode('list')}
          >
            List View
          </Button>
          <Button
            type={viewMode === 'grid' ? 'primary' : 'default'}
            onClick={() => setViewMode('grid')}
          >
            Grid View
          </Button>
        </div>
        {viewMode === 'list' ? (
          <List
            className="chainlist-list"
            bordered
            dataSource={filteredChains}
            renderItem={(chain) => (
              <List.Item>
                <strong>{chain.name}</strong> - {chain.type}
              </List.Item>
            )}
          />
        ) : (
          <Row gutter={[16, 16]} className="chainlist-grid">
            {filteredChains.map((chain) => (
              <Col xs={24} sm={12} md={8} lg={6} key={chain.name}>
                <Card
                  title={chain.name}
                >
                  <p>{chain.type}</p>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ChainList;
